module.exports = __webpack_public_path__ + "static/media/05-04.a722d546.png";